import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const MetadataInputLabel = props => {
  const {
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(InlineLabel, Object.assign({
    width: "90%",
    flexGrow: 1,
    marginBlockStart: "-25",
    typography: "body-125"
  }, rest, {
    children: children
  }));
};
MetadataInputLabel.displayName = 'MetadataInputLabel';
export default MetadataInputLabel;